import { Account } from '@lib/core/enum';
import { BaseUser } from '@lib/core/model';
import { Uuid } from '@lib/core/type';
import { Label } from '@lib/label';
import { BreadcrumbNameProvider } from '@proget-shared/breadcrumb';

import { UserEntraId } from './user-entra-id';
import { UserLdap } from './user-ldap';

export class User extends BaseUser implements BreadcrumbNameProvider {
  public readonly isLocalAccount: boolean;
  public readonly isAzureAccount: boolean;
  public readonly canChangePassword: boolean;

  constructor(
    uuid: Uuid,
    firstName: string,
    lastName: string,
    public readonly username: string,
    email: string,
    public phoneNumber: string,
    public readonly vip: boolean,
    public readonly createdAt: string,
    public readonly account: string,
    public readonly hasActiveActivation: boolean,
    public readonly superAdmin: boolean,
    public readonly type: string,
    public readonly ldap: UserLdap,
    public readonly entraId: UserEntraId,
    public readonly locked: boolean,
    public readonly labels: Label[],
    hasLocalPassword: boolean
  ) {
    super(null, uuid, firstName, lastName, email);

    this.isLocalAccount = type === Account.LOCAL;
    this.isAzureAccount = type === Account.AZURE;
    this.canChangePassword = this.isLocalAccount || this.isAzureAccount && hasLocalPassword;
  }

  getBreadcrumbTitle(): string {
    return this.getDisplayName();
  }
}
